import React, { memo } from 'react'
import cn, { Argument as ClassName } from 'classnames'
import { useSelector } from 'react-redux'

import { PageLayoutContainer } from '../../../lib/page-layout-container'
import { OrganisationInformationWidget } from '../../../common/features/organisation-information-widget'
import { OrganisationSettingsWidget } from '../../../common/features/organisation-settings-widget'
import { RootState } from '../../redux/store'
import hasClaimForCompany from '../../../lib/hasClaimForCompany'
import Claims from '../../../lib/claims'
import { OrganisationServicePartnersWidget } from '../../features/organisation-service-partners-widget'
import { useCompanyGetPartnerQuery } from '../../../common/redux/api/web-api'

export type SettingsPageProps = {
    className?: ClassName
    style?: React.CSSProperties
}

export const SettingsPage = memo(function SettingsPage({ className, style }: SettingsPageProps): React.ReactElement {
    const companyId = useSelector((state: RootState) => state.user.selectedCompanyId)
    const user = useSelector((state: RootState) => state.user)
    const canUpdateCompany = hasClaimForCompany(user, companyId || '', Claims.Admin)
    const { data: partner, isFetching: isPartnerFetching } = useCompanyGetPartnerQuery(
        { companyId: companyId ?? '' },
        { skip: !companyId }
    )

    return (
        <PageLayoutContainer className={cn(className)} style={style}>
            <OrganisationInformationWidget
                partner={partner}
                isPartnerFetching={isPartnerFetching}
                disabled={!canUpdateCompany}
            />
            <div className="grid">
                <div className="col-12 md:col-6">
                    <OrganisationSettingsWidget companyId={companyId} disabled={!canUpdateCompany} />
                </div>
                <div className="col-12 md:col-6">
                    <OrganisationServicePartnersWidget
                        companyId={companyId}
                        canManageServicePartners={canUpdateCompany}
                        partner={partner}
                        isPartnerFetching={isPartnerFetching}
                    />
                </div>
            </div>
        </PageLayoutContainer>
    )
})
